import { render, staticRenderFns } from "./PetTypeCatalogView.vue?vue&type=template&id=92691c98&scoped=true"
import script from "./PetTypeCatalogView.vue?vue&type=script&lang=js"
export * from "./PetTypeCatalogView.vue?vue&type=script&lang=js"
import style0 from "./PetTypeCatalogView.vue?vue&type=style&index=0&id=92691c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92691c98",
  null
  
)

export default component.exports